import _ from 'lodash';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Card, CardContent, Link, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import CandidateAvatar from './CandidateAvatar';

const CandidatePrintedDetails = ({ position, candidate, answerTranscripts, ...props }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isLinkOnlyCandidate = _.isUndefined(candidate.email) || _.isNull(candidate.email);
  return (
    <Box {...props}>
      <Card>
        <CardContent>
          <Box display="flex" alignItems="center">
            {
              candidate.thumbnail &&
              <CandidateAvatar
                candidateName={candidate.candidateName}
                thumbnailUrl={candidate.thumbnail.variants[0].contentHref}
                ml={1} mr={1} mt={1}
              />
            }
            <Box ml={1} pt={0.7} flexGrow={1}>
              <Typography variant="h6">
                {candidate.candidateName}
              </Typography>
              {
                !isLinkOnlyCandidate &&
                <Box mt={.5}>
                  <Link href={`mailto:${candidate.email}`}>
                    {candidate.email}
                  </Link>
                </Box>
              }
              <Box mt={.7}>
                <Typography variant="caption">
                  {t("Interview for {{jobTitle}}", position)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
      <Box style={{ marginTop: theme.spacing(4), display: "flex", flexDirection: "column", gap: theme.spacing(2) }}>
        <Typography variant="h6">
          {t("Full Transcript")}
        </Typography>
        {
          candidate.questions.map((question, index) => {
            const answer = candidate.answers[index];
            const transcript = answerTranscripts[answer.answerId];
            const hasTranscript = (transcript?.paragraphs ?? []).length > 0;
            return (
              <Box key={answer.answerId} style={{ breakInside: "avoid" }}>
                <Typography variant="subtitle2" gutterBottom>
                  {`Q${index + 1} - ${question.title}`}
                </Typography>
                {
                  !hasTranscript &&
                  <Box fontStyle="italic">
                    {t("No transcript available")}
                  </Box>
                }
                {
                  hasTranscript &&
                  <Box style={{ display: "flex", flexDirection: "column", gap: theme.spacing(1) }}>
                    {
                      transcript.paragraphs.map(paragraph => {
                        return (
                          <Box key={paragraph.startMillis}>
                            {paragraph.content}
                          </Box>
                        );
                      })
                    }
                  </Box>
                }
              </Box>
            );
          })
        }
      </Box>
    </Box>
  );
};

export default CandidatePrintedDetails;